import { Link } from "react-router-dom";
import { formatUSD } from "@/context/CartContext";
import { ExternalLink, ArrowRight } from "lucide-react";

export default function ProductCard({ product, index = 0 }) {
    const affiliateUrl = product.affiliate_url;
    const isAffiliate = !!affiliateUrl;

    const cardWrapperProps = isAffiliate
        ? {
              as: "a",
              href: `/shop/${product.slug}`,
          }
        : {};

    return (
        <Link
            to={product.to || `/shop/${product.slug}`}
            className="group block rise-in"
            style={{ animationDelay: `${index * 120}ms` }}
            data-testid={`product-card-${product.slug}`}
            {...cardWrapperProps}
        >
            <div className="relative aspect-[4/5] overflow-hidden bg-cream-warm rounded-sm">
                <img
                    src={product.image}
                    alt={product.name}
                    loading="lazy"
                    className={`w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.06]`}
                />
                <div
                    className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/35 to-transparent"
                    aria-hidden
                />
                {product.collection && (
                    <span className="absolute top-4 left-4 text-[0.6rem] tracking-[0.35em] uppercase text-forest px-3 py-1.5 rounded-full" style={{ background: "rgba(10,14,23,0.85)" }}>
                        {product.collection}
                    </span>
                )}
            </div>
            <div className="mt-5 flex items-start justify-between gap-4">
                <div>
                    <h3 className="font-serif text-2xl text-forest leading-tight group-hover:text-gold transition-colors duration-300">
                        {product.name}
                    </h3>
                    <p className="text-xs text-brown mt-1 tracking-wide">
                        {product.tagline}
                    </p>
                </div>
                <div className="text-right">
                    <p
                        className="font-serif text-xl text-forest"
                        data-testid={`product-price-${product.slug}`}
                    >
                        {product.price == null ? "Soon" : formatUSD(product.price)}
                    </p>
                    <p className="text-[0.6rem] tracking-[0.3em] uppercase text-gold mt-0.5">
                        {(product.category || "live").toString().toUpperCase()}
                    </p>
                </div>
            </div>
            <div
                className="mt-4 w-full text-center btn-pill btn-ghost group-hover:btn-primary justify-center pointer-events-none"
                data-testid={`provision-cta-${product.slug}`}
            >
                {product.source_type === "island_gold" ? "View product" : "Shop via Partner"} <ArrowRight size={12} />
            </div>
            {isAffiliate && (
                <span className="sr-only">External affiliate link</span>
            )}
            {/* External link icon overlay (visual only) */}
            <span className="sr-only">
                <ExternalLink size={1} />
            </span>
        </Link>
    );
}
